module.exports = __webpack_public_path__ + "img/git.22706b5c.svg";